import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {ForeignPortCode, PortCode, TemplateDto, TemplateSubmisionRequest, USPort, Vessel} from "../../shipper";
import {Observable, OperatorFunction} from "rxjs";
import {debounceTime, distinctUntilChanged, switchMap, tap} from "rxjs/operators";
import {countries} from "../countries";
import {NgbTypeahead, NgbTypeaheadSelectItemEvent} from "@ng-bootstrap/ng-bootstrap";
import {TemplateService} from "../template.service";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";

// @ts-ignore
@Component({
	selector: "vessel-info",
	templateUrl: "isf.vessel.form.html",
	standalone: true,
	imports: [
		FormsModule,
		NgbTypeahead,
		CommonModule
	],
	styles:[`
		table.vessel th, table.vessel td{
			width: 25%;
		}
		
		textarea{
			border: none;
			min-height: 140px;
		}
	`]
})
export class VesselData implements OnInit, AfterViewInit{
	
	@Input()
	template!:TemplateDto;
	
	@Input()
	isf!:TemplateSubmisionRequest;
	
	@Output()
	isfChange:EventEmitter<TemplateSubmisionRequest> = new EventEmitter<TemplateSubmisionRequest>();
	
	searchingVessel:boolean = false;
	
	selectedVessel:Vessel = <Vessel>{name:'ISF'};
	
	selectedEntryPort:USPort = <USPort>{name:'',portCode:''};
	
	selectedUnladingPort:USPort = <USPort>{name:'',portCode:''};
	
	selectedLadingPort:ForeignPortCode = <ForeignPortCode>{portName:'',portCode:'',country:''};
	
	selectedItPort:USPort = <USPort>{name:'',portCode:''};
	
	htsCountries:Array<{co:string,name:string}> = [];
	
	countries = countries;
	
	constructor(private ds:TemplateService) {}
	
	
	ngOnInit(): void {
		this.selectedVessel.name = this.isf.vessel || "ISF";
		this.selectedEntryPort.portCode = this.isf.entryPort;
		this.selectedUnladingPort.portCode = this.isf.unladingPort;
		this.selectedLadingPort.portCode = this.isf.ladingPort;
		this.selectedItPort.portCode = this.isf.itPort;
		
		this.initHtsCountries();
	}
	
	
	ngAfterViewInit(): void {}
	
	
	initHtsCountries(){
		
		let countries:Array<string> = this.template.parties
			.filter(p => p.partyType == "CBP_MID")
			.map(p => p.manufacturer.address.country);
		
		let co:Set<string> = new Set([...countries, this.template.manufacturer.address.country]);
		
		co.forEach((c:string) => {
			// @ts-ignore
			this.htsCountries.push({co:c, name: this.countries[c]})
		});
		
		if(this.htsCountries.length == 1){
			this.isf.exportCountry = this.htsCountries[0].co;
			this.isf.originCountry = this.htsCountries[0].co;
		}
	}
	
	
	format(){
		//this.isf.description = this.clean(this.isf.description);
		this.isf.vessel = this.clean(this.isf.vessel);
		// @ts-ignore
		this.selectedVessel.name = this.clean(this.selectedVessel.name);
	}
	
	
	/**
	 *
	 * @param ev
	 */
	cleanPortSearch(ev:any){
		
		const regex = /\D/g;
		
		if(this.isf.ladingPort !== null && this.isf.ladingPort != ''){
			this.isf.ladingPort = this.isf.ladingPort.replace(regex,"");
		}
		
		if(this.isf.unladingPort !== null && this.isf.unladingPort != ''){
			this.isf.unladingPort = this.isf.unladingPort.replace(regex,'');
		}
		
		if(this.isf.itPort !== null && this.isf.itPort != ''){
			this.isf.itPort = this.isf.itPort.replace(regex,'');
		}
		
		if(this.isf.entryPort !== null && this.isf.entryPort != ''){
			this.isf.entryPort = this.isf.entryPort.replace(regex,'');
		}
	}
	
	
	/**
	 *
	 * @param text
	 */
	clean(text:string|null){
		
		if(text == null || text == ""){ return null;}
		
		return text.toUpperCase();
	}
	
	
	/**
	 *
	 * @param ev
	 */
	dataChange(ev:any){
		this.format();
		this.isfChange.emit(this.isf);
	}
	
	
	/**
	 *
	 * @param ev
	 */
	etdChange(ev : Event){
		
		const selectedDate = (ev.target as HTMLInputElement).value;
		
		let twoWeeks = new Date().setDate(new Date(selectedDate).getDate() + 15);
		
		// @ts-ignore
		this.isf.eta = new Date(twoWeeks).toISOString().substring(0,10);
		
		this.isfChange.emit(this.isf);
	}
	
	
	/**
	 *
	 * @param text$
	 */
	search:OperatorFunction<string, readonly Vessel[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(300),
			distinctUntilChanged(),
			tap(() => this.searchingVessel = true),
			switchMap(term =>
				(term =='' || term.length < 3) ? [] : this.ds.getVessels(term)
			),
			tap(() => this.searchingVessel = false)
		);
	
	
	/**
	 *
	 * @param text$
	 */
	searchPorts: OperatorFunction<string, readonly PortCode[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(300),
			distinctUntilChanged(),
			tap(() => this.searchingVessel = true),
			switchMap(term =>
				(term =='' || term.length < 3) ? [] : this.ds.getPortCodes(term)
			),
			tap(() => this.searchingVessel = false)
		);
	
	
	/**
	 *
	 * @param text$
	 */
	searchForeignPorts: OperatorFunction<string, readonly ForeignPortCode[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(300),
			distinctUntilChanged(),
			tap(() => this.searchingVessel = true),
			switchMap(term =>
				(term =='' || term.length < 3) ? [] : this.ds.getForeignPortCodes(term)
			),
			tap(() => this.searchingVessel = false)
		);
	
	
	/**
	 *
	 * @param e
	 */
	vesselSelected(e:NgbTypeaheadSelectItemEvent){
		e.preventDefault();
		this.selectedVessel.name = e.item.name;
		this.isf.vessel = e.item.name;
		this.isfChange.emit(this.isf);
	}
	
	
	/**
	 *
	 * @param e
	 */
	entryPortSelected(e:NgbTypeaheadSelectItemEvent){
		e.preventDefault();
		this.isf.entryPort = e.item.portCode;
		this.selectedEntryPort = e.item;
		this.isfChange.emit(this.isf);
	}
	
	
	/**
	 *
	 * @param e
	 */
	unladingPortSelected(e:NgbTypeaheadSelectItemEvent){
		e.preventDefault();
		this.isf.unladingPort = e.item.portCode;
		this.selectedUnladingPort = e.item;
		this.isfChange.emit(this.isf);
	}
	
	/**
	 *
	 * @param e
	 */
	ladingPortSelected(e:NgbTypeaheadSelectItemEvent){
		e.preventDefault();
		this.isf.ladingPort = e.item.portCode;
		this.selectedLadingPort = e.item;
		this.isfChange.emit(this.isf);
	}
	
	/**
	 *
	 * @param e
	 */
	itPortSelected(e:NgbTypeaheadSelectItemEvent){
		e.preventDefault();
		this.isf.itPort = e.item.portCode;
		this.selectedItPort = e.item;
		this.isfChange.emit(this.isf);
	}
}
